import { Component, OnInit, HostListener, ElementRef } from "@angular/core";
import { CommonService } from "../../shared/common.service";
import { Router } from "@angular/router";
import { ApiService } from "../../api.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  isLoggedIn: boolean = false;
  userData: any;
  showProfileModal = false;
  notifications: any[] = [];
  showNotifications: boolean = false;
  unreadCount: number = 0;

  constructor(
    public commonService: CommonService,
    private router: Router,
    private apiService: ApiService,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.isLoggedIn = this.commonService.isLoggedIn();
    this.userData = this.commonService.getUserData();

    console.log("HeaderComponent initialized");
    
    // Fetch notifications if user is logged in
    if (this.isLoggedIn && this.userData) {
      this.loadNotifications();
    }
  }

  loadNotifications(): void {
    const userId = this.userData?.id || this.userData?.userId;
    if (!userId) {
      console.warn('User ID not found in userData');
      return;
    }

    this.apiService.getUserNotifications(userId.toString()).subscribe(
      (response: any) => {
        // Handle different response structures
        this.notifications = Array.isArray(response) ? response : (response.data || response.notifications || []);
        this.unreadCount = this.notifications.filter((n: any) => !n.isRead || n.isRead === false || n.is_read === 0).length;
        console.log('Notifications loaded:', this.notifications);
      },
      (error) => {
        console.error('Error fetching notifications:', error);
        this.notifications = [];
        this.unreadCount = 0;
      }
    );
  }

  getNotificationMessage(notification: any): string {
    return 'You have assigned to new query';
  }

  getNotificationFlow(notification: any): string {
    const parts: string[] = [];
    
    if (notification.study_name) {
      parts.push(notification.study_name);
    }
    if (notification.subject_id) {
      parts.push(notification.subject_id);
    }
    if (notification.folder_name) {
      parts.push(notification.folder_name);
    }
    if (notification.form_name) {
      parts.push(notification.form_name);
    }
    if (notification.field_name) {
      parts.push(notification.field_name);
    }
    
    return parts.join(' → ');
  }

  toggleNotifications(): void {
    this.showNotifications = !this.showNotifications;
  }

  closeNotifications(): void {
    this.showNotifications = false;
  }

  markNotificationAsRead(notification: any, event: Event): void {
    event.stopPropagation(); // Prevent triggering the notification click
    
    const notificationId = notification.id;
    if (!notificationId) {
      console.warn('Notification ID not found');
      return;
    }

    // Call API to mark as read
    this.apiService.markNotificationAsRead(notificationId).subscribe(
      (response: any) => {
        console.log('Notification marked as read:', notificationId);
        // Refresh the page after successfully marking as read
        window.location.reload();
      },
      (error) => {
        console.error('Error marking notification as read:', error);
        alert('Failed to mark notification as read. Please try again.');
      }
    );
  }

  openProfile() {
    this.userData = this.commonService.getUserData();
    console.log("User data in openProfile:", this.userData);
    this.showProfileModal = true;
  }

  closeProfile() {
    this.showProfileModal = false;
  }

  goToHome() {
    console.log("clicked on home logo");
    this.router.navigate(["/home"]);
  }

  logout() {
    console.log("Logout clicked in HeaderComponent");
    this.commonService.logout();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const clickedInside = this.elementRef.nativeElement.contains(target);
    
    if (!clickedInside && this.showNotifications) {
      this.closeNotifications();
    }
  }
}
